<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Need financing to support your business growth?</h2>
    <p>
      If you're finding it hard to connect with investors, you're not alone. Access to financing is a major obstacle for African companies. We're building a digital bridge across the financing gap through our Virtual Deal Rooms. Connect with investors who are looking for companies like yours and benefit from the support of our team doing initial eligibility checks.
    </p>
    <div class="action-wrap">
      <a
        @click="openLink"
        class="cta-button"
        :class="colorMode === 'light' ? 'medium-button' : ''"
        >Opportunities for African Businesses</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'financing-opportunities',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openLink() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'Financing Opportunities Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'Financing Opportunities Block',
      })
      this.$router.push({ path: '/about/deals' })
    },
  },
}
</script>
